import { render, staticRenderFns } from "./PersonLegalNature.vue?vue&type=template&id=a864a7c8"
import script from "./PersonLegalNature.vue?vue&type=script&lang=js"
export * from "./PersonLegalNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports